'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartCouponField } from './cart-coupon-field.component';
import { CartCouponNotice } from './cart-coupon-notice.component';

import { useCartCoupon } from '@/hooks/use-cart-coupon.hook';

export function CartCouponSection() {
  const {
    appliedCode,
    appliedItemCount,
    totalItemCount,
    notice,
    isApplying,
    isRemoving,
    errorMessage,
    apply,
    remove,
    clearError,
    dismissNotice,
  } = useCartCoupon();

  if (!notice && totalItemCount === 0) {
    return null;
  }

  return (
    <div className="px-6 pb-4" data-testid={DataTestIdEnum.CART_COUPON_SECTION}>
      {notice
        ? <CartCouponNotice kind={notice.kind} onDismiss={dismissNotice} />
        : (
            <CartCouponField
              appliedCode={appliedCode}
              appliedItemCount={appliedItemCount}
              totalItemCount={totalItemCount}
              isApplying={isApplying}
              isRemoving={isRemoving}
              errorMessage={errorMessage}
              onApply={(code) => void apply(code)}
              onRemove={() => void remove()}
              onClearError={clearError}
            />
          )}
    </div>
  );
}
